module.exports = __webpack_public_path__ + "img/Group 7@122x.1af06908.png";